import React from "react";
import { cn } from "@utils/cn";
import { Chip, Text } from "@ui-component-library";
export const SubscriptionCoverBanner = ({
  onClick,
  className = "",
  label,
  ...props
}) => {
  const baseClasses =
    "transition absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-5/6 w-[75%] rounded-lg p-3 cursor-pointer z-10";

  return (
    <>
      <div
        onClick={onClick}
        className={cn(baseClasses, className)}
        {...props}
      >
        Köp <b className="text-[#6856C3]">Treebula Plus</b> för att se {label}
      </div>
    </>
  );
};

export const SubscriptionCoverRow = ({
  onClick,
  className = "",
  containerClassName = "",
  children,
  shouldBlur = false,
  disableIcon = false,
  ...props
}) => {
  if (!shouldBlur) {
    return (
      <div className={cn("flex flex-row items-center gap-1 flex-nowrap", containerClassName)}>
        {children}
      </div>
    );
  }

  return (
    <div
      className={cn("flex flex-row items-center gap-1 justify-between flex-nowrap", onClick ? 'cursor-pointer' : 'cursor-default', className)}
      onClick={onClick ? () => onClick() : undefined}
      {...props}
    >
      <Text
        variant="text-sm/leading-none/normal"
        className={cn("blur-sm flex-nowrap", className)}
      >
        000
      </Text>
      {!disableIcon && (
        <Chip
          label="Plus"
          className="bg-[#F6F5FE] text-[#6856C3] fill-[#6856C3]"
          icon="SparkleFilled"
        />
      )}
    </div>
  );
};
